import { useState } from 'react'
import { Check, Copy } from 'lucide-react'

function CopyButton({ value }: { value: string }) {
  const [copied, setCopied] = useState(false)

  async function handleCopy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // Clipboard API unavailable (e.g. insecure context) - the text is still select-all, so manual copy still works.
    }
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={copied ? 'Copied!' : 'Copy to clipboard'}
      className="text-marine-dk hover:text-marine shrink-0 p-1"
    >
      {copied ? <Check aria-hidden="true" strokeWidth={2.5} className="w-4 h-4" /> : <Copy aria-hidden="true" className="w-4 h-4" />}
    </button>
  )
}

/**
 * A value shown exactly once - a generated password or a reset link - with a
 * copy button and a dismiss. Shared by every screen that issues one, so they
 * all hand a secret over the same way.
 */
export function SecretBanner({ label, value, onDismiss }: { label: string; value: string; onDismiss: () => void }) {
  return (
    <div className="bg-marine-lt border-l-4 border-marine p-3 flex items-center justify-between gap-4">
      <div className="min-w-0">
        <div className="text-[11px] font-bold text-ink">{label}</div>
        <div className="flex items-center gap-1.5 mt-1">
          <div className="text-sm font-mono text-marine-dk select-all break-all">{value}</div>
          <CopyButton value={value} />
        </div>
      </div>
      <button type="button" onClick={onDismiss} className="text-[11px] font-bold text-ink-mid hover:text-ink shrink-0">
        Dismiss
      </button>
    </div>
  )
}
